<!-- Flag country select -->
@switch (environment) {
	@case (EEnvironment.local || EEnvironment.dev) {
		<ng-container *ngTemplateOutlet="flagCountryTrigger" />
	}
	@default {
		@if (this.isAdministrator()) {
			<!-- <ng-container *ngTemplateOutlet="flagCountryTrigger" /> -->
			<ng-container *ngTemplateOutlet="flagCountryWithoutTrigger" />
		} @else {
			<ng-container *ngTemplateOutlet="flagCountryWithoutTrigger" />
		}
	}
}

<!-- Flag country  trigger -->
<ng-template #flagCountryTrigger>
	<button
		matRipple
		class="Menu__item Menu__item--isFull Menu--greenOne"
		[class.Button--isFull]="isFull"
		[matMenuTriggerFor]="flagCountriesMenu"
	>
		<app-flag-country class="Margin-right--s" [country]="country()" [width]="40" [height]="30" />
		<span>{{ country() }}</span>
	</button>
</ng-template>

<!-- Flag country without trigger -->
<ng-template #flagCountryWithoutTrigger>
	<button
		matRipple
		class="Menu__item Menu__item--isFull Menu--greenOne"
		[class.Button--isFull]="isFull"
	>
		<app-flag-country class="Margin-right--s" [country]="country()" [width]="40" [height]="30" />
		<span>{{ country() }}</span>
	</button>
</ng-template>

<!-- Flag country menu hidden -->
<mat-menu #flagCountriesMenu="matMenu" xPosition="before" class="Menu Menu--align-submenu">
	@for (country of countries; track country) {
		<button
			matRipple
			class="Menu__item Menu__item--isFull Menu--greenOne"
			[class.Button--isFull]="isFull"
			(click)="onSelectCountry(country)"
		>
			<app-flag-country class="Margin-right--s" [country]="country" [width]="40" [height]="30" />
			<span>{{ country }}</span>
		</button>
	}
</mat-menu>
